import './screen-size';
import './navigation';
import './togglize';
import './columnize';
import 'SLICK/slick.js';
import 'MFP/jquery.magnific-popup.js';
import './hero-video';
import './tabbit';
import './animations';
import { defineCustomElements } from '@smore/core';

defineCustomElements(window);

window.getURLparams = function (targetParam) {
	let pageURL = decodeURIComponent(window.location.search.substring(1));
	// break up end of url into an array of 'param=value' strings
	let urlVars = pageURL.split("&");
	let paramKeyVal;
	let keyIndex = 0;
	let valIndex = 1;

	for (let i = 0; i < urlVars.length; i++) {
		// break up 'param=value' strings into arrays of ['param', 'value']
		paramKeyVal = urlVars[i].split("=");
		if (paramKeyVal[keyIndex] === targetParam) {
			// url parameter matches function parameter, get the value
			return paramKeyVal[valIndex] === undefined ? true : paramKeyVal[valIndex];
		}
	}
	return 0;
};

(function($){

  $(document).ready(function() {
      
    function reduceAllMotion() {
      console.log('reducing motion...');
      $('video').prop('autoplay',false)
        .siblings('.video-control-button-container').find('.video-control-button').attr('aria-label','play');
    }
    
    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }

    let $faqToggles = $(".faq-column").togglize({ action: "toggle", animate: true, animateSpeed: ".5s", firstOpen: false, adaptiveHeight: true });
    let $toggles = $(".togglize-me").togglize({ action: "toggle", animate: true, animateSpeed: ".5s", firstOpen: false });
    let $accordions = $(".accordionize-me").togglize({ action: "accordion", animate: true, animateSpeed: "0.75s" })
    let twoCols = $(".two-col-content").twoColumnize()
		
		$('.featured-floor-plans').slick({
      lazyLoad: "ondemand",
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
			centerMode: true,
			centerPadding: '40%',
			// appendDots: '.slick-prev',
			// appendArrows: 
			arrowsPlacement: 'afterSlides',
      rows: 0,
      infinite: true,
      prevArrow: `<button class="slick-prev slick-arrow" type="button" style=""><span class="custom-arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="15" viewBox="0 0 30 15" fill="none">
									<path d="M0.292893 8.20711C-0.0976311 7.81658 -0.0976311 7.18342 0.292893 6.79289L6.65685 0.428933C7.04738 0.0384083 7.68054 0.0384084 8.07107 0.428933C8.46159 0.819457 8.46159 1.45262 8.07107 1.84315L2.41421 7.5L8.07107 13.1569C8.46159 13.5474 8.46159 14.1805 8.07107 14.5711C7.68054 14.9616 7.04738 14.9616 6.65685 14.5711L0.292893 8.20711ZM30 7.5L30 8.5L1 8.5L1 7.5L1 6.5L30 6.5L30 7.5Z" fill="#D0D180"/>
									</svg></span><span aria-hidden="true"></span><span class="slick-sr-only">Prev</span></button>`,
      nextArrow: `<button class='slick-next slick-arrow' type='button' style=''><span class='custom-arrow-right'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="15" viewBox="0 0 30 15" fill="none">
									<path d="M29.7071 6.79289C30.0976 7.18342 30.0976 7.81658 29.7071 8.20711L23.3431 14.5711C22.9526 14.9616 22.3195 14.9616 21.9289 14.5711C21.5384 14.1805 21.5384 13.5474 21.9289 13.1569L27.5858 7.5L21.9289 1.84315C21.5384 1.45262 21.5384 0.819457 21.9289 0.428932C22.3195 0.0384078 22.9526 0.0384078 23.3431 0.428932L29.7071 6.79289ZM0 7.5V6.5H29V7.5V8.5H0V7.5Z" fill="#D0D180"/>
									</svg></span><span aria-hidden='true'></span><span class='slick-sr-only'>Next</span></button>`,
      responsive: [
        {
          breakpoint: 768,
          settings: {
						centerMode: false,
						centerPadding: '10px',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
		
		$('.solo-lightbox-image').magnificPopup({
			type: "image",
			image: {
				titleSrc: function(item) {
					// lightbox images are not setup with the title attribute
          // so this will return nothing, which is what we want for now
					return item.el.find('img').attr('title');
				}
			},
			closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span aria-hidden="true">&#215;</span></button>',
      tClose: "Close Lightbox (Esc)",
      closeOnContentClick: true
		})

		$(".multi-image-lightbox").each(function (e) {
      $(this)
        .find("a.image-link")
        .magnificPopup({
          // delegate: "a",
          type: "image",
          image: {
            markup:
              '<div class="mfp-figure">' +
              '<div class="mfp-close"></div>' +
              '<div class="mfp-img"></div>' +
              '<div class="mfp-bottom-bar">' +
              '<div class="mfp-title"></div>' +
              '<div class="mfp-counter"></div>' +
              "</div>" + // end .mfp-bottom-bar
              "</div>", // Popup HTML markup. `.mfp-img` di
            titleSrc: function (item) {
              // console.log(item);
              return item.img.attr("alt");
            },
            verticalFit: true // Fits image in area vertically
          },
          gallery: {
            enabled: true,
            navigateByImgClick: true,

            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

            tPrev: "Previous (Left arrow key)", // title for left button
            tNext: "Next (Right arrow key)", // title for right button
            tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
          }
        });
    });
		
		$(".gallery-panel__image-collection").each(function (e) {
      $(this).magnificPopup({
        delegate: "a",
				mainClass: 'gallery-panel-lightbox-wrapper',
        type: "image",
        image: {
          titleSrc: function (item) {
            // lightbox images are not setup with the title attribute
            // so this will return nothing, which is what we want for now
            return item.el.find("img").attr("title");
          }
        },
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span aria-hidden="true">&#215;</span></button>',
        tClose: "Close Lightbox (Esc)",
        closeOnContentClick: true,
        gallery: {
          enabled: true
        }
      });
    });
		
		$('.tabbed-gallery').tabbit();
      
  })
})(jQuery);